// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sd-author-entry-form--button-wrapper[data-v-2705b427]{text-align:right}", "",{"version":3,"sources":["webpack://./resources/js/components/authors/AuthorEntryForm.vue"],"names":[],"mappings":"AACA,uDACE,gBAAF","sourcesContent":["\n.sd-author-entry-form--button-wrapper {\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
